module.exports = __webpack_public_path__ + "img/spin-wheel.5e96a14a.png";